"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var vite_auto_warm_exports = {};
__export(vite_auto_warm_exports, {
  autoWarmPlugin: () => import_warmRoutesPlugin.autoWarmPlugin
});
module.exports = __toCommonJS(vite_auto_warm_exports);
var import_warmRoutesPlugin = require("./vite/plugins/warmRoutesPlugin");
//# sourceMappingURL=vite-auto-warm.js.map
